import { TasksGroup } from "@common-models/task-group";
import { taskgroupsSelectors } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { memo } from "react";
import classes from "./mobile-board.module.scss";

interface Props {
  groupId: string;
  tasksCount?: number;
}

function MobileGroupHeader({ groupId, tasksCount }: Props) {
  const group: TasksGroup = useAppSelector((state) =>
    taskgroupsSelectors.selectById(state, groupId)
  );

  if (!group) return null;

  return (
    <div className={classes.groupHeader}>
      <span
        className={classes.groupColorDot}
        style={{ background: group.colorAccent || "#00c875" }}
      />
      <span className={classes.groupName}>{group.name || "Group"}</span>
      {typeof tasksCount === "number" && (
        <span className={classes.groupCount}>{tasksCount}</span>
      )}
    </div>
  );
}

export default memo(MobileGroupHeader);
